import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

export const StyledAccordion = styled(Accordion)(() => ({
    border: '1px solid #DFDFDF',
    borderRadius: '4px',
    boxShadow: 'none',
    marginBottom: '8px',
    '&.Mui-expanded': {
        border: '1px solid #DFDFDF',
        borderRadius: '4px',
    },
    '&:before': {
        display: 'none',
    },
}));

export const StyledAccordionSummary = styled(AccordionSummary)(() => ({
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #DFDFDF',
    padding: '0px 10px',
    minHeight: '40px',
    height: '64px',
    '& .MuiAccordionSummary-content': {
        margin: '10px 0',
    },
    '& .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root': {
        color: '#000',
        fontWeight: '700',
    },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(() => ({
    padding: '15px',
}));
